import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';

// The KB root doc for one scope: agentKb/main for the system knowledge base,
// accounts/{accountId}/agentKb/main for a customer's own. The two have
// identical shapes below this point, which is why every ref here takes a scope
// rather than existing twice.
const agentKbRootDoc = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  // Required for the account scope; ignored for the system scope.
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) => {
  const firestore = db ? db : firebase.firestore();
  if (scope === 'account') {
    if (!accountId) {
      throw new Error('An account-scoped agent KB ref needs an accountId');
    }
    return firestore
      .collection('accounts')
      .doc(accountId)
      .collection(STORE_CONSTANTS.AGENT_KB_COLLECTION)
      .doc(STORE_CONSTANTS.AGENT_KB_MAIN_DOC_ID);
  }
  return firestore
    .collection(STORE_CONSTANTS.AGENT_KB_COLLECTION)
    .doc(STORE_CONSTANTS.AGENT_KB_MAIN_DOC_ID);
};

export default agentKbRootDoc;
